/**
 * Skyscanner booking links.
 *
 * We use Skyscanner's official referrals deep-link endpoint instead of a
 * hand-built website URL. The endpoint is locale-agnostic (no `/voli` vs
 * `/flights` slug to guess) and is designed to land on a results page rather
 * than bouncing to the homepage — the previous `/transport/voli/` slug bounced.
 * Verified working in-browser 2026-06-20.
 *
 * NOTE: no affiliate tracking is attached. Wrapping this in the Travelpayouts
 * `tp.media` redirect made it bounce, so we link straight to Skyscanner. Set
 * `mediaPartnerId` once we have a Skyscanner partner id to monetise the clicks.
 */
export interface SkyscannerUrlParams {
  origin: string;
  destination: string;
  /** Outbound date, YYYY-MM-DD */
  departureDate: string;
  /** Return date for round-trips, YYYY-MM-DD */
  returnDate?: string;
  passengers?: number;
  /** Skyscanner affiliate id; omit for an untracked link */
  mediaPartnerId?: string;
}

const SKYSCANNER_REFERRALS = 'https://www.skyscanner.net/g/referrals/v1/flights/day-view/';

export function buildSkyscannerUrl(params: SkyscannerUrlParams): string {
  const pax = Math.max(1, Math.trunc(params.passengers ?? 1));
  const qs = new URLSearchParams({
    origin: params.origin,
    destination: params.destination,
    outboundDate: params.departureDate,
    adults: String(pax),
    currency: 'EUR',
    market: 'IT',
    locale: 'it-IT',
  });
  if (params.returnDate) qs.set('inboundDate', params.returnDate);
  if (params.mediaPartnerId) qs.set('mediaPartnerId', params.mediaPartnerId);
  return `${SKYSCANNER_REFERRALS}?${qs.toString()}`;
}
